/**
 * Configuration API Service
 * 
 * Handles all API calls related to system and policy configurations
 */
import { apiService as api } from './api.service';

// API endpoints
const ENDPOINTS = {
  CONFIGS: '/config/configs',
  CONFIGS_POLICY: '/config/configs/policy',
  CONFIG_BY_NAME: (name) => `/config/${name}`,
  CONFIG_SCHEMA: (name) => `/config/schema/${name}`,
};


export const configService = {
  // Get all configurations
  getAllConfigs: async () => api.get(ENDPOINTS.CONFIGS),
  getAllPolicyConfigs: async () => api.get(ENDPOINTS.CONFIGS_POLICY),
  // Get configuration by name
  getConfigByName: async (name) => api.get(ENDPOINTS.CONFIG_BY_NAME(name)),
  
  // Get configuration schema by name
  getConfigSchema: async (name) => api.get(ENDPOINTS.CONFIG_SCHEMA(name)),
  
  // Update configuration
  updateConfig: async (name, configData) => api.put(ENDPOINTS.CONFIG_BY_NAME(name), configData),
}; 